






























import VueOptions from '@utils/VueOptions'

settings =
  name: 'RepeatUntilRuleForm'

  vue:
    props: ['form']

    data: ->
      repeatType: 'never'

    computed:
      neverLabel: -> if @form.seasonal then 'End of Season' else 'Never'

    mounted: ->
      @initializeData()

    methods:
      initializeData: ->
        if @form.rrule.count
          @repeatType = 'count'
        else if @form.rrule.until
          @repeatType = 'until'
        else
          @repeatType = 'never'

      hiRuleChanged: ->
        @$emit 'change', @form

      hiChangeCount: (value) ->
        @form.rrule.count = value
        @$emit 'change', @form

    watch:
      'form.rrule': (rrule) ->
        @initializeData()

      repeatType: (value) ->
        switch value
          when 'never'
            delete @form.rrule.until
            delete @form.rrule.count
          when 'until'
            delete @form.rrule.count
          when 'count'
            delete @form.rrule.until

export default VueOptions.vue settings
